import {rebuildBlocks} from './helpers';

let tables;
const tablesPositions = [];

function getCoords(elem) {
    const abiturContent = $_vikon('#vikon-content-abitur');
    const isAbitur = abiturContent.length;

    const {body} = document;
    const docEl = document.documentElement;

    let scrollTop;
    let scrollLeft;
    if (isAbitur) {
        scrollTop = abiturContent.scrollTop();
        scrollLeft = abiturContent.scrollLeft();
    } else {
        scrollTop = window.pageYOffset || docEl.scrollTop;
        scrollLeft = window.pageXOffset || docEl.scrollLeft;
    }

    const box = elem.getBoundingClientRect();

    const clientTop = docEl.clientTop || body.clientTop || 0;
    const clientLeft = docEl.clientLeft || body.clientLeft || 0;

    const top = box.top + scrollTop - clientTop;
    const left = box.left + scrollLeft - clientLeft;
    return {
        top,
        left,
        height: box.height,
        width: box.width,
    };
}

function getPositionsTables() {
    tables.each((i, elem) => {
        $_vikon(elem).attr('data-table-id', i);
        tablesPositions[i] = getCoords(elem);

        const vikonResponsiveTable = $_vikon(elem).closest('.vikon-responsive-table')[0];
        tablesPositions[i].left += vikonResponsiveTable.pageXOffset || vikonResponsiveTable.scrollLeft;

        tablesPositions[i].theadHeight = getCoords($_vikon(elem).find('thead:first')[0]).height;
    });
}

function setContainers() {
    $_vikon('.container-thead').remove();
    tables.each((i, elem) => {
        const columns = [];
        const thead = $_vikon(elem).find('thead');
        $_vikon(thead).find('tr').each((iTr, elemTr) => {
            columns[iTr] = [];
            $_vikon(elemTr).find('th').each((iTh, elemTh) => {
                const vPaddingWithBorder = ($_vikon(elemTh).innerHeight() - $_vikon(elemTh).height()) / 2;
                const gPaddingWithBorder = ($_vikon(elemTh).innerWidth() - $_vikon(elemTh).width()) / 2;
                const vBorder = ($_vikon(elemTh).outerHeight() - $_vikon(elemTh).innerHeight()) / 2;
                const gBorder = ($_vikon(elemTh).outerWidth() - $_vikon(elemTh).innerWidth()) / 2;
                const vPadding = vPaddingWithBorder - vBorder;
                const gPadding = gPaddingWithBorder - gBorder;

                columns[iTr][iTh] = {
                    vPadding,
                    gPadding,
                    height: $_vikon(elemTh).height(),
                    width: getCoords(elemTh).width,
                    text: $_vikon(elemTh).html(),
                    fontSize: $_vikon(elemTh).css('font-size'),
                    fontFamily: $_vikon(elemTh).css('font-family'),
                    color: $_vikon(elemTh).css('color'),
                    backgroundColor: $_vikon(elemTh).css('background-color'),
                    verticalAlign: $_vikon(elemTh).css('vertical-align'),
                };
            });
        });

        const copyThead = document.createElement('thead');
        copyThead.innerHTML = $_vikon(thead).html();

        $_vikon(copyThead).find('tr').each((iTr, elemTr) => {
            $_vikon(elemTr).find('th').each((iTh, elemTh) => {
                const cell = columns[iTr][iTh];
                $_vikon(elemTh).css({
                    'padding-top': cell.vPadding,
                    'padding-left': cell.gPadding,
                    'padding-bottom': cell.vPadding,
                    'padding-right': cell.gPadding,
                    height: cell.height,
                    'font-size': cell.fontSize,
                    'font-family': cell.fontFamily,
                    width: cell.width,
                    'min-width': cell.width,
                    'max-width': cell.width,
                    color: cell.color,
                    'background-color': cell.backgroundColor,
                    'vertical-align': cell.verticalAlign,
                });
            });
        });

        const copyTable = document.createElement('table');
        copyTable.className = 'table table-bordered table-condensed';
        copyTable.style.cssText = 'margin-bottom: 0';
        copyTable.innerHTML = $_vikon(copyThead).html();

        const container = document.createElement('div');
        container.className = 'container-thead';
        const {left} = tablesPositions[i];
        container.style.cssText = `position: fixed; top: 0; left: ${left
        }px; background-color: #fff; border-bottom: 1px solid #000; display: none;`;
        container.setAttribute('data-table-id', i);

        $_vikon(container).html(copyTable);
        $_vikon('body').append(container);
    });
}

export function showHideThead() {
    $_vikon('.container-thead').hide();
    if (!isAccessability()) {
        const abiturContent = $_vikon('#vikon-content-abitur');
        const isAbitur = abiturContent.length;
        let scrollTop;
        let scrollLeft;
        if (isAbitur) {
            scrollTop = abiturContent.scrollTop();
            scrollLeft = abiturContent.scrollLeft();
        } else {
            scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;
        }
        tables.each((i, elem) => {
            const vikonResponsiveTable = elem.closest('div.vikon-responsive-table');
            const scrollVikonResponsiveTable = vikonResponsiveTable.pageXOffset || vikonResponsiveTable.scrollLeft;
            if ((tablesPositions[i].top) < scrollTop
                && (tablesPositions[i].top + tablesPositions[i].height - tablesPositions[i].theadHeight) > scrollTop
            ) {
                const container = $_vikon(`div[data-table-id="${i}"]`);
                container.css('left', tablesPositions[i].left - scrollLeft - scrollVikonResponsiveTable);
                container.show();
            }
        });
    }
}

export function initScrollTheadTable() {
    if (!isAccessability()) {
        tables = $_vikon('.table-scroll-thead:visible');
        getPositionsTables();
        setContainers();
        showHideThead();
    }
}

export function isAccessability() {
    if (window.sessionStorage) {
        const accessability = window.sessionStorage.getItem('accessability');
        return !(accessability === null || accessability === '0');
    }
    return true;
}

$_vikon(() => {
    initScrollTheadTable();
    $_vikon(document)
        .on('click', 'a.showpart-btn-list', () => {
            if (!isAccessability()) {
                getPositionsTables();
                setContainers();
                showHideThead();
            }
        });
    $_vikon(window)
        .on('resize', () => {
            if (!isAccessability()) {
                getPositionsTables();
                setContainers();
                showHideThead();
            }
        })
        .on('scroll', () => {
            if (!isAccessability()) {
                showHideThead();
            }
        });
    $_vikon('.abitur-modal')
        .on('scroll', () => {
            if (!isAccessability()) {
                showHideThead();
            }
        });

    $_vikon('a[data-toggle="tab"]').on('hidden.bs.tab', (e) => {
        initScrollTheadTable();
    });
    $_vikon(document).on('modal-open', () => {
        initScrollTheadTable();
    });

    $_vikon('.vikon-responsive-table').on('scroll', function () {
        if (!isAccessability()) {
            const tableId = $_vikon(this).find('table:first').data('table-id');
            const scrollLeft = this.pageXOffset || this.scrollLeft;
            if (tablesPositions.length > 0) {
                $_vikon(`div[data-table-id="${tableId}"]`).css('left', tablesPositions[tableId].left - scrollLeft);
            }
        }
    });

    $_vikon(document).on('accessability', () => {
        if (!isAccessability()) {
            initScrollTheadTable();
        } else {
            showHideThead();
        }
        const vikonContent = $_vikon('#vikon-content');
        const isAbitur = vikonContent.length && vikonContent.hasClass('abitur');
        if (isAbitur) {
            $_vikon('.block-item').css({height: '0px'});
            rebuildBlocks();
        }
    });
});
